export interface PriceInput {
  listPrice: number;
  bookingFee: number;
  deliveryFee: number;
  discountTotal: number;
  pointsUsed: number;
  transferType: 'none' | 'received' | 'given';
  transferAmount: number;
}

export interface PriceDistribution {
  n: number;
  median: number;
  q1: number;
  q3: number;
}

export function actualPaid(input: PriceInput): number {
  const values = [input.listPrice, input.bookingFee, input.deliveryFee, input.discountTotal, input.pointsUsed, input.transferAmount];
  if (values.some((value) => !Number.isInteger(value) || value < 0)) throw new Error('E_PRICE_NEGATIVE');
  const result = input.transferType === 'received'
    ? input.transferAmount + input.bookingFee + input.deliveryFee
    : input.listPrice - input.discountTotal - input.pointsUsed + input.bookingFee + input.deliveryFee;
  if (!Number.isInteger(result) || result < 0) throw new Error('E_PRICE_NEGATIVE');
  return result;
}

function median(values: number[]): number {
  const middle = Math.floor(values.length / 2);
  if (values.length % 2 === 1) return values[middle] as number;
  return ((values[middle - 1] as number) + (values[middle] as number)) / 2;
}

export function priceDistribution(values: number[]): PriceDistribution | null {
  if (values.length === 0) return null;
  const sorted = [...values].sort((a, b) => a - b);
  const middle = Math.floor(sorted.length / 2);
  const lower = sorted.slice(0, middle);
  const upper = sorted.slice(sorted.length % 2 === 0 ? middle : middle + 1);
  return {
    n: sorted.length,
    median: median(sorted),
    q1: lower.length ? median(lower) : sorted[0] as number,
    q3: upper.length ? median(upper) : sorted[sorted.length - 1] as number,
  };
}

export const seasonPassOffer = {
  name: '앉아봄 시즌 패스', priceKrw: 3900, durationDays: 365, autoRenew: false,
  free: { watchedSeats: 5, activePolls: 1, pollDays: 3 },
  paid: { watchedSeats: 50, activePolls: 5, pollDays: 14 },
  activation: 'disabled_safe',
} as const;
